var React = require('react');

function VideoControlsRecordInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"12","cy":"12","r":"8.25","fill":"currentColor"}));
}

VideoControlsRecordInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsRecordInline;

VideoControlsRecordInline.default = VideoControlsRecordInline;
